var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPwn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 50,
    viewBox: "0 0 154 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.572998,
    y: 0.14563,
    width: 41.0097,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.572754,
    y: 22.5146,
    width: 41.0097,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.572754,
    y: 7.60194,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3979,
    y: 7.60194,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3979,
    y: 15.0583,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.572754,
    y: 15.0583,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.572754,
    y: 29.9709,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.572754,
    y: 37.4272,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.572754,
    y: 44.8835,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4951,
    y: 7.60194,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4951,
    y: 0.14563,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4951,
    y: 15.0583,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4951,
    y: 22.5146,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4951,
    y: 29.9709,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4951,
    y: 37.4272,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 112.417,
    y: 7.60194,
    width: 15.534,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 137.893,
    y: 37.4272,
    width: 15.534,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 112.417,
    y: 0.14563,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 142.243,
    y: 44.8835,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 112.417,
    y: 44.8835,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 112.417,
    y: 15.0583,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 126.709,
    y: 15.0583,
    width: 6.83495,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 112.417,
    y: 22.5146,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 129.815,
    y: 22.5146,
    width: 6.83495,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 112.417,
    y: 29.9709,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 132.922,
    y: 29.9709,
    width: 6.83495,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 112.417,
    y: 37.4272,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 142.243,
    y: 7.60194,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 142.243,
    y: 0.14563,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 142.243,
    y: 15.0583,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 142.243,
    y: 22.5146,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 142.243,
    y: 29.9709,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3203,
    y: 7.60194,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3203,
    y: 0.14563,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3203,
    y: 15.0583,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3203,
    y: 22.5146,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3203,
    y: 29.9709,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3203,
    y: 37.4272,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 62.0874,
    y: 44.8835,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4077,
    y: 37.4272,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4077,
    y: 29.9709,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 80.728,
    y: 44.8835,
    width: 11.1845,
    height: 4.97087,
    fill: "#00FFE0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwn);
export default __webpack_public_path__ + "static/media/pwn.5f26fbf751586cff8d1f1cf75ed883b4.svg";
export { ForwardRef as ReactComponent };